import React from 'react';
import { FormHelperText, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { AdminFieldLabel } from '@/admin/shared/AdminFieldLabel';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';
import { useListCountriesQuery } from '../../api/brokerGroupsApi';
import { BROKER_GROUP_FIELD_LABELS } from '../brokerGroupFormValues';

/**
 * The broker group's country, from listCountries, by name. Changing it clears a state or
 * timezone the new country doesn't have.
 */
export const BrokerGroupCountryField = () => {
	const { values, touched, errors, setFieldValue } = useFormikContext();
	const { data: countries = {} } = useListCountriesQuery();
	const error = touched.country && errors.country;

	const options = Object.entries(countries)
		.map(([id, { countryName }]) => ({ id, name: countryName }))
		.sort((a, b) => a.name.localeCompare(b.name));

	const handleChange = (countryCode) => {
		const nextCountry = countries[countryCode];
		setFieldValue('country', countryCode ?? '');
		if (values.state && !nextCountry?.states.includes(values.state)) {
			setFieldValue('state', null);
		}
		if (values.timezone && !nextCountry?.timezones.includes(values.timezone)) {
			setFieldValue('timezone', '');
		}
	};

	return (
		<Grid size={{ xs: 12, sm: 4 }}>
			<AdminFieldLabel name='country'>{BROKER_GROUP_FIELD_LABELS.country}</AdminFieldLabel>
			<ResponsiveAutocomplete
				options={options}
				value={values.country || null}
				onChange={handleChange}
				error={Boolean(error)}
			/>
			{error && <FormHelperText error>{error}</FormHelperText>}
		</Grid>
	);
};
